import { styled } from '@mui/material/styles';
import { Card, CardActionArea, Dialog, DialogTitle, MobileStepper, Tab, Typography } from '@mui/material';
import { isDark } from 'global/styles';

export const HomeContent = styled('div')(({ theme }) => ({
  maxWidth: theme.breakpoints.values.lg,
  [theme.breakpoints.down('xl')]: {
    width: '90%',
  },
  marginLeft: 'auto',
  marginRight: 'auto',
}));

export const HomeIconBox = styled('span')(({ theme }) => ({
  margin: theme.spacing(1),
  display: 'inline-flex',
  alignItems: 'center',
}));

export const HomeInlineIcon = styled('span')(({ theme }) => ({
  color: theme.palette.grey[700],
  marginBottom: theme.spacing(-0.5),
  display: 'inline-flex',
  alignItems: 'center',
}));

export const HomePerformLogo = styled('img')({
  maxWidth: '249.5px',
  width: '100%',
  height: 'auto',
});

export const HomeGif = styled('img')({
  width: '100%',
  maxWidth: '420px',
  height: 'auto',
});

export const HomePerformLogoWrapper = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
  justifyContent: 'space-around',
}));

export const HomeGifWrapper = styled('div')({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-around',
});

export const HomeFlex = styled('div')({
  display: 'flex',
  margin: 'auto',
  flexWrap: 'wrap',
  justifyContent: 'flex-start',
});

export const HomeFlexLabel = styled(Typography)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'none',
  alignItems: 'center',
  color: isDark(theme) ? theme.palette.common.white : theme.palette.primary.main,
}));

export const HomeFlexIcons = styled('p')({
  display: 'flex',
  flexWrap: 'none',
  alignItems: 'center',
  justifyContent: 'center',
});

export const HomeFlexTitle = styled(DialogTitle)({
  '& h2': {
    display: 'flex',
    flexWrap: 'none',
    alignItems: 'center',
  },
});

export const HomeCard = styled(Card)(({ theme }) => ({
  width: '30%',
  textAlign: 'left',
  display: 'flex',
  flexDirection: 'column',
  marginTop: theme.spacing(4),
  marginLeft: '1.5%',
  marginRight: '1.5%',
  [theme.breakpoints.down('lg')]: {
    width: '100%',
  },
}));

export const HomeSectionHeader = styled(Typography)(({ theme }) => ({
  margin: `${theme.spacing(6)} auto`,
  textAlign: 'left',
  fontWeight: 'bold',
  [theme.breakpoints.down('lg')]: {
    textAlign: 'center',
    margin: `${theme.spacing(3)} auto ${theme.spacing(1)}`,
  },
}));

export const HomeSectionHeaderSubtitle = styled('div')({
  textAlign: 'left',
});

export const HomeCardAction = styled(CardActionArea)({
  height: '100%',
});

export const HomeRecentListItem = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.action.disabledBackground,
  [theme.breakpoints.down('lg')]: {
    width: '100%',
  },
  height: theme.spacing(4),
  margin: `${theme.spacing(1)} auto`,
}));

export const HomeActionStepper = styled(MobileStepper)({
  flexGrow: 1,
});

export const HomeDialog = styled(Dialog)({
  '& .MuiDialog-paper': {
    height: '500px',
    maxHeight: '80vh',
  },
});

export const HomeColorTab = styled(Tab)(({ theme }) => ({
  color: theme.palette.primary.main,
  opacity: 'inherit',
}));

export const HomeNoWrap = styled('span')({
  whiteSpace: 'nowrap',
});
